import Header from '../components/Header';
import MainComponent from '../components/MainComponent';
import './Home.css';
import Practices from '../components/Practices';
import Cases from '../components/Cases';
import BlackCases from '../components/BlackCases';
import Video from '../components/Video';
import FAQ from '../components/FAQ';
import Advantages from '../components/Advantages';
import Footer from '../components/Footer';
import Authors from '../components/Authors';
import TopAdvantages from '../components/TopAdvantages';
import ThreeProducts from '../components/ThreeProducts';
import SiteHeader from '../components/SiteHeader';

import { useTranslation } from 'react-i18next';
import i18n from '../i18n';


export default function Home() {
    const { t } = useTranslation();
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    return(
        <div className='home-page'>
            <SiteHeader
                    pageLinks={[
                        { label: t('$AboutUs'), href: '/about' }
                    ]}
                    cta={[{ label: t('$Login'), to: `/login` },
                          { label: t('$Reg', 'Зарегистрироваться'), to: `/register` }
                    ]}
                    mode='default'
                />
            <div className='main-component'>
                {/* <Header /> */}
                <MainComponent />
            </div>
            <div className='top-advantages'>
                <TopAdvantages />
            </div>
            <ThreeProducts />
            {/* <Practices /> */}
            <div className='cases-component'>
                <Cases />
            </div>
            <BlackCases />
            <Video />
            <Authors />
            <div className='bottom-component'>
                <Advantages />
            </div>
            <FAQ />
            <Footer />
        </div>
    );
}